import Cookies from "js-cookie";
import { API_URL } from "../../components/shared";

export const api = async ({ path, method = "GET", body }) => {
  const token = Cookies.get("login-token");

  const settings = {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if (method !== "GET") {
    settings.headers["Content-Type"] = "application/json";
  }
  if (body) {
    settings.body = JSON.stringify(body);
  }

  const res = await fetch(`${API_URL}/${path}`, settings);
  // error
  if (!res.ok) {
    return {
      error: res.detail || res.statusText || "Unknown error",
    };
  }
  // no content
  if (res.status === 204) {
    return {};
  }

  const json = await res.json();
  if (json === null) {
    return {};
  }

  return json;
};

export const reportApi = async ({ path, method = "GET", body }) => {
  const res = await fetch('https://h3yql61tgd.execute-api.us-east-1.amazonaws.com/enterprise-reporting-app-prod/dashboard/reports', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body)
  })
  return res.json()
};

export const get = (path) => api({ path });
export const post = (path, body) => api({ path, method: "POST", body });
export const patch = (path, body) => api({ path, method: "PATCH", body });
export const del = (path) => api({ path, method: "DELETE" });
